<template>
    <b-modal id="customer-show-xml-recipe" class="customer-show-xml-recipe" ref="modal" title="Cargar Recetario XML"
        hide-footer>
        <div class="row form-group">
            <div class="col-sm-12">
                <select v-model="doctor_id" id="show_recipe_doctor" class="custom-select form-control">
                    <option :value="null">Selecciona Doctor/a</option>
                    <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
                        {{ doctor.name }}
                    </option>
                </select>
                <label for="show_recipe_doctor" class="wabident-info">Doctor asignado</label>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-sm-12">
                <b-form-file v-model="file" :state="Boolean(file)" placeholder="Elige un archivo para subir"
                    class="wabident-file-input" :required="true" accept="text/xml" :disabled="is_loading"></b-form-file>
            </div>
        </div>

        <div class="form-group row">
            <div class="col text-center">
                <button @click="createRecipe" class="btn btn-primary btn-wabident vertical-align-middle"
                    :disabled="!is_valid || is_loading">
                    <span v-if="is_loading">
                        Subiendo ...
                        <i class="fas fa-spin fa-circle-notch"></i>
                    </span>
                    <span v-else>Subir Talonario</span>
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            doctor_id: null,
            is_loading: false,
            file: null,
        }
    },
    computed: {
        is_valid() {
            return this.doctor_id && this.file;
        },
        doctors() {
            if (!this.clinic) return [];
            return this.clinic.doctors.filter((d) => {
                return d.is_active;
            });
        },
        ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
    },
    methods: {
        getFormData() {
            let ret = new FormData();
            ret.append("doctor_id", this.doctor_id);
            ret.append("file", this.file);
            return ret;
        },
        show() {
            this.doctor_id = null;
            this.file = null;
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
        createRecipe() {
            if (!this.is_loading) {
                this.is_loading = true;
                let formData = this.getFormData();
                axios
                    .post(`/clinic/${this.clinic.id}/xml_recipes`, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((response) => {
                        this.msgwindow.success("Talonario subido con éxito");
                        this.hide();
                    })
                    .catch((err) => {
                        console.log("[ERR] createDocument", err);
                        this.errorwindow.show("Error", "Error creando documento");
                    })
                    .then(() => {
                        this.is_loading = false;
                        this.$emit('submit');
                    });
            }
        },
    },
}
</script>